import React from 'react';

interface ShuttersProps extends React.SVGProps<SVGSVGElement> {
  patternUrl: string;
}

export const Shutters76mmClearviewRevealFit = ({
  patternUrl,
  ...props
}: ShuttersProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="prefix__Layer_1"
      data-name="Layer 1"
      viewBox="0 0 555.2 410"
      preserveAspectRatio="none"
      {...props}
    >
      <defs>
        <pattern
          id="shutters76"
          patternUnits="userSpaceOnUse"
          width="100"
          height="100"
        >
          <image href={patternUrl} x="0" y="0" width="100" height="100" />
        </pattern>
      </defs>
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1={41.4}
          y1={-89.41}
          x2={41.4}
          y2={-62.31}
          gradientTransform="matrix(1 0 0 -1 0 -22.11)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.24} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.3} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-2"
          x1={7045.24}
          y1={-89.41}
          x2={7045.24}
          y2={-62.31}
          gradientTransform="rotate(180 3650.545 -11.055)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-3"
          x1={41.4}
          y1={-116.81}
          x2={41.4}
          y2={-89.71}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-4"
          x1={7045.24}
          y1={-116.81}
          x2={7045.24}
          y2={-89.71}
          gradientTransform="rotate(180 3650.545 -11.055)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-5"
          x1={41.4}
          y1={-144.28}
          x2={41.4}
          y2={-117.18}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-6"
          x1={7045.24}
          y1={-144.28}
          x2={7045.24}
          y2={-117.18}
          gradientTransform="rotate(180 3650.545 -11.055)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-7"
          x1={41.4}
          y1={-171.76}
          x2={41.4}
          y2={-144.66}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-8"
          x1={7045.24}
          y1={-171.76}
          x2={7045.24}
          y2={-144.66}
          gradientTransform="rotate(180 3650.545 -11.055)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-9"
          x1={41.4}
          y1={-199.21}
          x2={41.4}
          y2={-172.11}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-10"
          x1={7045.24}
          y1={-199.21}
          x2={7045.24}
          y2={-172.11}
          gradientTransform="rotate(180 3650.545 -11.055)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-11"
          x1={41.4}
          y1={-226.66}
          x2={41.4}
          y2={-199.56}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-12"
          x1={7045.24}
          y1={-226.66}
          x2={7045.24}
          y2={-199.56}
          gradientTransform="rotate(180 3650.545 -11.055)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-13"
          x1={41.4}
          y1={-254.11}
          x2={41.4}
          y2={-227.03}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-14"
          x1={7045.24}
          y1={-254.11}
          x2={7045.24}
          y2={-227.03}
          gradientTransform="rotate(180 3650.545 -11.055)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-15"
          x1={41.4}
          y1={-281.56}
          x2={41.4}
          y2={-254.46}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-16"
          x1={7045.24}
          y1={-281.56}
          x2={7045.24}
          y2={-254.46}
          gradientTransform="rotate(180 3650.545 -11.055)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-17"
          x1={41.4}
          y1={-309.01}
          x2={41.4}
          y2={-281.91}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-18"
          x1={7045.24}
          y1={-309.01}
          x2={7045.24}
          y2={-281.91}
          gradientTransform="rotate(180 3650.545 -11.055)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-19"
          x1={41.4}
          y1={-336.51}
          x2={41.4}
          y2={-309.41}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-20"
          x1={7045.24}
          y1={-336.51}
          x2={7045.24}
          y2={-309.41}
          gradientTransform="rotate(180 3650.545 -11.055)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-21"
          x1={41.4}
          y1={-363.98}
          x2={41.4}
          y2={-336.88}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-22"
          x1={7045.24}
          y1={-363.98}
          x2={7045.24}
          y2={-336.88}
          gradientTransform="rotate(180 3650.545 -11.055)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-23"
          x1={41.4}
          y1={-391.46}
          x2={41.4}
          y2={-364.36}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-24"
          x1={7045.24}
          y1={-391.46}
          x2={7045.24}
          y2={-364.36}
          gradientTransform="rotate(180 3650.545 -11.055)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-25"
          x1={405.4}
          y1={-77.88}
          x2={405.4}
          y2={-73.26}
          gradientTransform="matrix(1 0 0 -1 0 -22.11)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.37} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-26"
          x1={405.4}
          y1={-105.34}
          x2={405.4}
          y2={-100.72}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-27"
          x1={405.4}
          y1={-132.8}
          x2={405.4}
          y2={-128.18}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-28"
          x1={405.4}
          y1={-160.27}
          x2={405.4}
          y2={-155.64}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-29"
          x1={405.4}
          y1={-187.73}
          x2={405.4}
          y2={-183.11}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-30"
          x1={405.4}
          y1={-215.19}
          x2={405.4}
          y2={-210.57}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-31"
          x1={405.4}
          y1={-242.65}
          x2={405.4}
          y2={-238.03}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-32"
          x1={405.4}
          y1={-270.12}
          x2={405.4}
          y2={-265.5}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-33"
          x1={405.4}
          y1={-297.58}
          x2={405.4}
          y2={-292.95}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-34"
          x1={405.4}
          y1={-325.04}
          x2={405.4}
          y2={-320.42}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-35"
          x1={405.4}
          y1={-352.5}
          x2={405.4}
          y2={-347.88}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-36"
          x1={405.4}
          y1={-379.96}
          x2={405.4}
          y2={-375.34}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <style>
          {
            '.prefix__cls-1{fill:#e6dfd5}.prefix__cls-3{opacity:.2}.prefix__cls-4{fill:#ececec;stroke:gray;stroke-width:.95px;stroke-miterlimit:10}.prefix__cls-44{fill:gray;opacity:.2}'
          }
        </style>
      </defs>
      <path
        fill="url(#shutters76)"
        d="M514.4 12.7H12.6v383.5H542V12.7zm0 356.6H297.2v-11.4h217.2zm0-16.1H297.2v-22.9h217.2zm0-27.5H297.2v-22.9h217.2zm0-27.4H297.2v-22.9h217.2zm0-27.4H297.2V248h217.2zm0-27.5H297.2v-22.9h217.2zm0-27.5H297.2V193h217.2zm0-27.4H297.2v-22.9h217.2zm0-27.5H297.2v-22.9h217.2zm0-27.5H297.2v-22.9h217.2zm0-27.5H297.2V83.3h217.2zm0-27.4H297.2V55.8h217.2zm0-27.4H297.2V39.7h217.2z"
      />
      <path
        d="M513.4 12.3h-217v.1h-39.1v-.1H12.2v384.5h245.4v-.1h39.1v.1h245.4V12.3zM256.6 94.2h-216V67.6h216v26.6zm0 27.5h-216V95.1h216v26.6zm0 27.5h-216v-26.6h216v26.6zm0 27.5h-216V150h216v26.7zm0 27.3h-216v-26.6h216V204zm0 27.5h-216V205h216v26.5zm0 27.5h-216v-26.6h216V259zm0 27.5h-216v-26.6h216v26.6zm0 27.4h-216v-26.6h216v26.6zm0 27.5h-216v-26.6h216v26.6zM40.6 66.8V40.2h216v26.5h-216zm0 302v-26.5h216v26.5zm216-355.6v26.1h-216V13.2zm-217 382.6H13.1V13.2h26.5zm217 0h-216v-26.1h216v26.1zm20 .1h-19.1V13.1h19.1zm236.8-38.6h-216v-3.7h216zm0 1v10.5H297.3v-10.5zm-216.1-5.6v-21.9h216.1v21.9zM513.4 330h-216v-3.7h216zm-216.1-4.7v-21.8h216.1v21.9l-216.1-.1zm216.1-22.8h-216v-3.8h216zm-216.1-4.7v-21.9h216.1v21.9zM513.4 275h-216v-3.7h216zm-216.1-4.6v-21.9h216.1v21.9zm216.1-22.9h-216v-3.7h216zm-216.1-4.6V221h216.1v21.9zm216.1-22.8h-216v-3.7h216zm-216.1-4.6v-21.9h216.1v21.9zm216.1-22.9h-216v-3.7h216zM297.3 188v-21.9h216.1V188zm216.1-22.9h-216v-3.7h216zm-216.1-4.6v-21.9h216.1v21.9zm216.1-22.9h-216V134h216zM297.3 133v-21.8h216.1v21.9l-216.1-.1zm216.1-22.7h-216v-3.8h216zm-216.1-4.7V83.7h216.1v21.8l-216.1.1zm216.1-22.8h-216v-3.7h216zm-216.1-4.7V56.3h216.1v21.9l-216.1-.1zm216.1-22.8h-216v-3.7h216zm-216.1-4.6V40.2h216.1v10.5zm.1-37.5h216v26.1h-216V13.2zm-20 382.7V13.1h19.1v27.1h.1v10.5h-.1v5.5h.1v21.9h-.1v5.5h.1v21.8h-.1v5.5h.1V133h-.1v5.5h.1v21.9h-.1v5.5h.1V188h-.1v5.5h.1v21.9h-.1v5.5h.1v21.9h-.1v5.5h.1v21.9h-.1v5.5h.1v21.8h-.1v5.5h.1v21.9h-.1v5.5h.1v21.9h-.1v5.5h.1v10.5h-.1v27.1l-19.1.5zm20-.1v-26.1h216v26.1zm243.5 0h-26.5V13.2h26.5z"
        style={{
          isolation: 'isolate',
        }}
        opacity={0.2}
        fill="#4d4d4d"
      />
      <g className="prefix__cls-3">
        <path
          className="prefix__cls-4"
          d="M13.1 72.2h2.5v35.7h-2.5zM13.1 301.1h2.5v35.7h-2.5z"
        />
      </g>
      <g className="prefix__cls-3">
        <path
          className="prefix__cls-4"
          d="M538.9 72.2h2.5v35.7h-2.5zM538.9 301.1h2.5v35.7h-2.5z"
        />
      </g>
      <path
        fill="url(#prefix__linear-gradient)"
        d="M42.2 40.2h-1.6v27.1l1.6-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-2)"
        d="M255.1 40.2h1.5v27.1l-1.5-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-3)"
        d="M42.2 67.6h-1.6v27.1l1.6-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-4)"
        d="M255.1 67.6h1.5v27.1l-1.5-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-5)"
        d="M42.2 95.1h-1.6v27.1l1.6-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-6)"
        d="M255.1 95.1h1.5v27.1l-1.5-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-7)"
        d="M42.2 122.5h-1.6v27.1l1.6-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-8)"
        d="M255.1 122.5h1.5v27.1l-1.5-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-9)"
        d="M42.2 150h-1.6v27.1l1.6-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-10)"
        d="M255.1 150h1.5v27.1l-1.5-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-11)"
        d="M42.2 177.5h-1.6v27.1l1.6-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-12)"
        d="M255.1 177.5h1.5v27.1l-1.5-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-13)"
        d="M42.2 205h-1.6v27l1.6-27z"
      />
      <path
        fill="url(#prefix__linear-gradient-14)"
        d="M255.1 205h1.5v27l-1.5-27z"
      />
      <path
        fill="url(#prefix__linear-gradient-15)"
        d="M42.2 232.3h-1.6v27.1l1.6-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-16)"
        d="M255.1 232.3h1.5v27.1l-1.5-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-17)"
        d="M42.2 259.8h-1.6v27.1l1.6-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-18)"
        d="M255.1 259.8h1.5v27.1l-1.5-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-19)"
        d="M42.2 287.3h-1.6v27.1l1.6-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-20)"
        d="M255.1 287.3h1.5v27.1l-1.5-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-21)"
        d="M42.2 314.8h-1.6v27.1l1.6-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-22)"
        d="M255.1 314.8h1.5v27.1l-1.5-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-23)"
        d="M42.2 342.2h-1.6v27.1l1.6-27.1z"
      />
      <path
        fill="url(#prefix__linear-gradient-24)"
        d="M255.1 342.2h1.5v27.1l-1.5-27.1z"
      />
      <g opacity={0.54}>
        <path
          fill="url(#prefix__linear-gradient-25)"
          d="M296.9 51.2h217v4.6h-217z"
        />
        <path
          fill="url(#prefix__linear-gradient-26)"
          d="M296.9 78.6h217v4.6h-217z"
        />
        <path
          fill="url(#prefix__linear-gradient-27)"
          d="M296.9 106h217v4.6h-217z"
        />
        <path
          fill="url(#prefix__linear-gradient-28)"
          d="M296.9 133.5h217v4.6h-217z"
        />
        <path
          fill="url(#prefix__linear-gradient-29)"
          d="M296.9 161h217v4.6h-217z"
        />
        <path
          fill="url(#prefix__linear-gradient-30)"
          d="M296.9 188.5h217v4.6h-217z"
        />
        <path
          fill="url(#prefix__linear-gradient-31)"
          d="M296.9 215.9h217v4.6h-217z"
        />
        <path
          fill="url(#prefix__linear-gradient-32)"
          d="M296.9 243.4h217v4.6h-217z"
        />
        <path
          fill="url(#prefix__linear-gradient-33)"
          d="M296.9 270.9h217v4.6h-217z"
        />
        <path
          fill="url(#prefix__linear-gradient-34)"
          d="M296.9 298.3h217v4.6h-217z"
        />
        <path
          fill="url(#prefix__linear-gradient-35)"
          d="M296.9 325.7h217v4.6h-217z"
        />
        <path
          fill="url(#prefix__linear-gradient-36)"
          d="M296.9 353.2h217v4.6h-217z"
        />
      </g>
      <path
        style={{
          isolation: 'isolate',
        }}
        fill="none"
        stroke="#4d4d4d"
        strokeMiterlimit={10}
        opacity={0.2}
        d="M0 0h555.2v409.9H0z"
      />
      <path
        fill="url(#shutters76)"
        d="M0 0v409.9h555.2V0zm542 396.6H13.2V13.2H542z"
      />
      <path
        d="M554.2 1v407.9H1V1h553.2M12.3 397.6H543V12.2H12.3v385.4M555.2 0H0v409.9h555.2V0zM13.3 396.6V13.2H542v383.4z"
        fill="#4d4d4d"
      />
      <path
        className="prefix__cls-44"
        d="M550.84 4.38l3.37-3.39v407.99l-3.37-3.36V4.38zM4.38 4.38L1.01.99v407.99l3.37-3.36V4.38zM4.37 405.64l-3.38 3.37h553.22l-3.36-3.37H4.37z"
      />
      <path
        className="prefix__cls-44"
        d="M4.37 4.36L.99.99h553.22l-3.36 3.37H4.37z"
      />
    </svg>
  );
};
